<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <v-spacer />
        <Tutoriales />
      </v-row>

      <v-row>
        <v-col cols="8">
          <v-card shaped>
            <v-card-title class="titulo_card">{{ $t("Campaña SMS") }}</v-card-title>
            <v-card-text>
              <FormSMSCampaign ref="form_sms_campaign" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card shaped>
            <v-card-title class="titulo_card">{{ $t("Seleccione los clientes") }}</v-card-title>
            <v-card-text>
              <ClientesCampaign
                  tipo="sms"
                  @on_update_clientes_seleccionados="update_clientes_seleccionados"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "NuevaSMSCampaign",
  methods: {
    /**
     * Cuando se actualiza los clientes seleccionados del newsletter, lo actualizamos también el form
     * @param clientes
     */
    update_clientes_seleccionados(clientes){
      this.$refs.form_sms_campaign.update_clientes(clientes)
    }
  },
  components: {
    FormSMSCampaign: () => import('@/views/Marketing/components/FormSMSCampaign'),
    ClientesCampaign: () => import('@/views/Marketing/components/ClientesCampaign')
  }
}
</script>
